import { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Container, Header, Text } from '@gasbuddy/react-components';
import { useBubbles } from './bubbleHelpers';
import styles from './GasbackBrands.module.css';

const cx = classnames.bind(styles);

export default function GasbackBrands({
  brands,
}) {
  const { bubbles, containerRef } = useBubbles(brands);

  return (
    <Fragment>
      <Container>
        <Text centered>
          <Header as="h2">
            Start saving on gas with
            <br />
            everyday purchases.
          </Header>
          <Text className={cx('subtext')} as="p" centered>Earn free gas from retailers you already know and love. We’re always adding new offers so check back for the latest and greatest ways to earn free gas.</Text>
        </Text>
      </Container>
      <br />
      <br />
      <div className={cx('bubbles')} ref={containerRef}>
        {bubbles.map(({ title, logo, x, y }) => (
          <div
            className={cx('bubbleContainer')}
            style={{ left: `${x}px`, top: `${y}px`, height: '100px', width: '100px' }}
            key={title || logo}
          >
            <a className={cx('bubble')}>
              <img src={logo} alt={title || 'Brand Logo'} className={cx('bubbleImage')} />
            </a>
          </div>
        ))}
      </div>
    </Fragment>
  );
}


GasbackBrands.propTypes = {
  brands: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
  })),
};

GasbackBrands.defaultProps = {
  brands: [],
};
